export default __webpack_public_path__ + "static/media/products_511.0873fa57.jpg";